var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 197,
    viewBox: "0 0 180 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2_99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.6728 63.3951H13.9352V67.4074H28.6728V63.3951Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.8457 73.534H3.28705V77.5463H39.8457V73.534Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.4321 133.719H7.93213V137.731H45.4321V133.719Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.8796 152.392H7.46912V156.404H45.8796V152.392Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.2963 97.2222C14.9382 97.2222 9.76849 92.0525 9.76849 85.6944C9.76849 79.3364 14.9382 74.1667 21.2963 74.1667C27.6543 74.1667 32.8241 79.3364 32.8241 85.6944C32.8241 92.0525 27.6543 97.2222 21.2963 97.2222ZM21.2963 78.1636C17.145 78.1636 13.7654 81.5432 13.7654 85.6944C13.7654 89.8457 17.145 93.2253 21.2963 93.2253C25.4475 93.2253 28.8271 89.8457 28.8271 85.6944C28.8271 81.5432 25.4475 78.1636 21.2963 78.1636Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M160.247 1.31174H145.509V5.32408H160.247V1.31174Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M174.414 11.4506H131.883V15.463H174.414V11.4506Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M152.886 36.5741C145.972 36.5741 140.355 30.9568 140.355 24.0432C140.355 17.1296 145.972 11.5124 152.886 11.5124C159.799 11.5124 165.417 17.1296 165.417 24.0432C165.417 30.9568 159.799 36.5741 152.886 36.5741ZM152.886 15.5247C148.179 15.5247 144.367 19.3519 144.367 24.0432C144.367 28.7346 148.194 32.5617 152.886 32.5617C157.577 32.5617 161.404 28.7346 161.404 24.0432C161.404 19.3519 157.577 15.5247 152.886 15.5247Z",
    fill: "#666565"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M29.8302 1.2037H13.4105V5.21605H29.8302V1.2037Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M39.892 11.1574H3.33331V15.1698H39.892V11.1574Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M21.6204 36.2346C15.0463 36.2346 9.69135 30.8796 9.69135 24.3056C9.69135 17.7315 15.0463 12.3766 21.6204 12.3766C28.1944 12.3766 33.5494 17.7315 33.5494 24.3056C33.5494 30.8796 28.1944 36.2346 21.6204 36.2346ZM21.6204 16.3889C17.2531 16.3889 13.7037 19.9383 13.7037 24.3056C13.7037 28.6729 17.2531 32.2222 21.6204 32.2222C25.9876 32.2222 29.537 28.6729 29.537 24.3056C29.537 19.9383 25.9876 16.3889 21.6204 16.3889Z",
    fill: "#666565"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M23.6265 41.5895H19.6142V51.5432H23.6265V41.5895Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M23.3024 101.157H19.2901V109.429H23.3024V101.157Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M117.839 0H113.827V38.4568H117.839V0Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M145.957 196.451C139.028 196.451 133.395 190.818 133.395 183.889C133.395 176.96 139.028 171.327 145.957 171.327C152.886 171.327 158.519 176.96 158.519 183.889C158.519 190.818 152.886 196.451 145.957 196.451ZM145.957 175.324C141.235 175.324 137.392 179.167 137.392 183.889C137.392 188.611 141.235 192.454 145.957 192.454C150.679 192.454 154.522 188.611 154.522 183.889C154.522 179.167 150.679 175.324 145.957 175.324Z",
    fill: "#ED6D46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M158.534 130.37H154.522V168.935H158.534V130.37Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M107.994 62.0679H103.981V103.858H107.994V62.0679Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M40.6482 127.809C33.7191 127.809 28.0864 122.176 28.0864 115.247C28.0864 108.318 33.7191 102.685 40.6482 102.685C47.5772 102.685 53.2099 108.318 53.2099 115.247C53.2099 122.176 47.5772 127.809 40.6482 127.809ZM40.6482 106.682C35.9259 106.682 32.0833 110.525 32.0833 115.247C32.0833 119.969 35.9259 123.812 40.6482 123.812C45.3704 123.812 49.213 119.969 49.213 115.247C49.213 110.525 45.3704 106.682 40.6482 106.682Z",
    fill: "#ED6D46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M6.14197 110.031C5.46296 110.031 4.76852 110.031 4.08951 110.031H0V106.019H4.10494C15.8025 106.034 27.8549 106.034 36.5432 103.071C45.8488 99.892 50.1697 93.642 50.1697 83.3796V62.2068H54.1821V83.3796C54.1821 95.4167 48.8426 103.102 37.8395 106.852C29.0586 109.861 17.5 110.015 6.14197 110.015V110.031Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M117.84 14.9383H97.5926V18.9506H117.84V14.9383Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M179.367 51.7593H126.003V55.7716H179.367V51.7593Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M53.3642 161.867H0V165.88H53.3642V161.867Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M88.2871 173.596H84.2747V186.481H88.2871V173.596Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M66.7284 97.2222H63.6729V68.4105H95.0926V72.4228H67.6852V93.2253C87.8087 93.2253 103.858 92.8549 119.09 77.6235L120.509 76.2037L123.349 79.0432L121.929 80.463C105.293 97.0988 87.4074 97.2376 66.7438 97.2376L66.7284 97.2222Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M7.63886 193.596H5.63269V178.657H43.7191V174.259H5.69442V170.247H47.7315V182.654H9.64504V189.568C23.0092 189.506 35.0463 188.889 45.4475 187.731L47.4382 187.515L47.8858 191.497L45.895 191.713C34.8302 192.948 21.9599 193.58 7.63886 193.58V193.596Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M20.6715 135.331L16.6792 135.732L18.485 153.728L22.4773 153.327L20.6715 135.331Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M32.713 140.467L31.064 153.06L35.0424 153.581L36.6914 140.988L32.713 140.467Z",
    fill: "#666565"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M64.3673 169.167H62.3611V150.509H100.447V141.049H62.4228V137.037H104.46V154.506H66.3734V165.154C79.7376 165.093 91.7747 164.475 102.176 163.318C119.877 161.559 134.861 152.762 140.602 141.049H117.623V137.037H146.466L145.509 139.707C140.339 154.151 123.102 165.231 102.593 167.284C91.5586 168.519 78.6882 169.151 64.3673 169.151V169.167Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M54.1513 0H50.1389V63.7346H54.1513V0Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M154.892 42.037H150.88V54.7531H154.892V42.037Z",
    fill: "#666565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M180 124.954H177.994C173.904 124.954 169.877 123.673 165.988 122.438C162.731 121.404 159.66 120.432 157.13 120.432C154.815 120.432 152.083 121.25 148.935 122.191C144.614 123.488 139.707 124.954 133.904 124.954C128.781 124.954 125.123 123.796 121.559 122.67C117.932 121.528 114.506 120.448 109.398 120.448C105.818 120.448 103.92 121.003 101.312 121.775C96.7747 123.117 90.5401 124.954 71.7747 124.954H69.7685V106.235H73.7808V120.941C90.4166 120.818 96.0339 119.151 100.185 117.932C102.901 117.13 105.247 116.435 109.414 116.435C115.139 116.435 119.028 117.67 122.778 118.843C126.188 119.923 129.414 120.941 133.904 120.941C139.12 120.941 143.735 119.568 147.793 118.349C151.096 117.361 154.228 116.42 157.13 116.42C160.278 116.42 163.642 117.485 167.191 118.611C170.802 119.753 174.522 120.926 177.994 120.926H180V124.938V124.954Z",
    fill: "#1F7FB8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M2.00617 52.8858H0V48.8735H2.00617C32.3302 48.8735 48.3951 46.2191 59.321 39.3981C64.2284 36.3426 80.2315 24.8457 80.2315 5.52469H84.2438C84.2438 10.0154 85.4012 25.0309 100.231 29.9537L102.13 30.5864L100.864 34.3827L98.966 33.75C92.1914 31.4969 87.0988 27.2068 83.858 20.9877C83.2407 19.7994 82.716 18.5957 82.284 17.4228C79.0123 27.3611 71.713 36.3889 61.4198 42.7932C49.7994 50.0463 33.1327 52.8704 1.99074 52.8704L2.00617 52.8858Z",
    fill: "#19943B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M106.296 44.6142C101.574 44.6142 97.7315 48.4568 97.7315 53.179C97.7315 57.9012 101.574 61.7438 106.296 61.7438C111.019 61.7438 114.861 57.9012 114.861 53.179C114.861 48.4568 111.019 44.6142 106.296 44.6142ZM106.296 65.7407C99.3673 65.7407 93.7346 60.108 93.7346 53.179C93.7346 46.25 99.3673 40.6173 106.296 40.6173C113.225 40.6173 118.858 46.25 118.858 53.179C118.858 60.108 113.225 65.7407 106.296 65.7407Z",
    fill: "#ED6D46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M125.941 182.469H56.7284V186.481H125.941V182.469Z",
    fill: "#666565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_99"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 196.451,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBig);
export default __webpack_public_path__ + "static/media/logo_big.17e1e497cb19b6d5e558f8d04703ab9f.svg";
export { ForwardRef as ReactComponent };